import React, { useEffect, useState } from "react";
import { isValidToken } from "../services/auth.service";
import { useLocation, useNavigate } from "react-router-dom";

const AuthGuard = ({ component }: any) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/signin-success") {
      setLoading(false);
      return;
    }

    if (!isValidToken()) {
      navigate("/");
      return;
    }
    setLoading(false);
  }, []);  


  if (loading) {
    return null;
  }

  return <React.Fragment>{component}</React.Fragment>;
};

export default AuthGuard;
